import React from "react";
import  "./Meaning.css";
import Synonyms from "./Synonyms";


export default function Meaning(props) {
      return(
        <div className="Meaning">
            <h3>{props.meaning.partOfSpeech}</h3>
            {props.meaning.definitions.map(function (definition, index) {
                return ( 
                    <div key={index}>  
                    <ul>
                        <li>{definition.definition}
                    <br />
                    <em>{definition.example}   <Synonyms synonyms={definition.synonyms} /></em>
                        </li> 
                    </ul>
                    </div>
                );
            })}
        </div>
    );
} 
          